import { Dialog as MuiDialog, dialogClasses, Slide, styled } from '@mui/material';
import { forwardRef, PropsWithChildren } from 'react';
import { TransitionProps } from 'react-transition-group/Transition';

import { DialogProps } from './Dialog';
import DialogInner from './DialogInner';

export default function DialogBottomSheet({ title, children, onClose, actions, subtitle, ...props }: Omit<DialogProps, 'variant'>) {
    return (
        <StyledDialog fullWidth
            onClose={ onClose }
            slots={{ transition: TransitionUp }}
            { ...props }
        >
            <DialogInner title={ title }
                subtitle={ subtitle }
                onClose={ onClose }
                actions={ actions }
            >
                { children }
            </DialogInner>
        </StyledDialog>
    );
}

const StyledDialog = styled(MuiDialog)({
    [`.${ dialogClasses.paper }`]: {
        position: 'fixed',
        width: '100%',
        bottom: 0,
        margin: 0,
        maxHeight: '85vh'
    }
});

const TransitionUp = forwardRef<unknown, PropsWithChildren<TransitionProps>>(({ children, ...props }, ref) => {
    return (
        <Slide direction="up" 
            ref={ ref }
            { ...props }
        >
            { children }
        </Slide>
    );
});
